var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_6f8ce691"]},_vm.$listeners),[_c('cube-button',{attrs:{"outline":"","loading":(_vm.loading)},on:{"_click":_vm.clickBtn}},[_vm._v("加载按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }